// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b126d0a8","455":"519661f5","488":"5d3d7cdc","977":"6ab2af03"}[chunkId] + ".chunk.js";
};